import { render, staticRenderFns } from "./ItemMensagen.vue?vue&type=template&id=d786f10c&scoped=true"
import script from "./ItemMensagen.vue?vue&type=script&lang=js"
export * from "./ItemMensagen.vue?vue&type=script&lang=js"
import style0 from "./ItemMensagen.vue?vue&type=style&index=0&id=d786f10c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d786f10c",
  null
  
)

export default component.exports